import { TemplatePart } from "../types";

export function splitPartsByType(
  parts: TemplatePart[],
  type: TemplatePart["type"]
) {
  return parts.reduce((acc, part, ind) => {
    if (parts[ind].type === type) {
      return acc;
    }

    if (ind === 0 || parts[ind - 1].type === type) {
      acc.push([part]);
    } else {
      acc[acc.length - 1].push(part);
    }

    return acc;
  }, [] as TemplatePart[][]);
}
